import axios from "axios";

const baseCancelSourceObject = {
  sourceValue: null,

  get value() {
    return this.sourceValue;
  },

  set value(newValue) {
    this.sourceValue = newValue;
  }
};

const CancelToken = axios.CancelToken;
const cancelSource = {...baseCancelSourceObject};
const groupCancelSource = {...baseCancelSourceObject};

export {CancelToken, cancelSource, groupCancelSource};